import { createAction, props } from '@ngrx/store';

import {
  type TemplateConfigurationSetupName,
  type TemplateConfigurationSetupParams,
} from '@blaze-dashboard/ai-chat-domain';

export const startTemplateConfigurationSetup = createAction(
  '[AI Chat] Start Template Configuration Setup',
  props<{ name: TemplateConfigurationSetupName; params: TemplateConfigurationSetupParams }>(),
);

export const startTemplateConfigurationSetupSuccess = createAction(
  '[AI Chat] Start Template Configuration Setup success',
);

export const startTemplateConfigurationSetupFailure = createAction(
  '[AI Chat] Start Template Configuration Setup failure',
  props<{ chatConversationId?: string; name: TemplateConfigurationSetupName; error: string }>(),
);

export const exitTemplateConfigurationSetup = createAction(
  '[AI Chat] Exit Template Configuration Setup',
);

export const exitTemplateConfigurationSetupSuccess = createAction(
  '[AI Chat] Exit Template Configuration Setup success',
);

export const exitTemplateConfigurationSetupFailure = createAction(
  '[AI Chat] Exit Template Configuration Setup failure',
  props<{ error: string }>(),
);
